import { shopPrefix } from '../../config';
import { http } from '../axios';
import { ChangeAmountByFilterRequest } from './decreaseAmountBulkInListByFilter';
import { BulkActionResponse } from '../../store/api';

export type SetAmountByFilterRequest = ChangeAmountByFilterRequest & {
    targetAmount: number;
};

const url = `${shopPrefix}/v2/selectionlists/:selectionlistId/bulk/quantity/filter/setAmount`;

export const setAmountBulkInListByFilter = (selectionlistId: string, body: SetAmountByFilterRequest) => {
    return http
        .put<BulkActionResponse>(url, body, {
            pathParams: {
                selectionlistId
            }
        })
        .then(res => res.data);
};
